export default "__VITE_ASSET__X6N$kH1f__"